import React from "react";
import "./InfoPage.css";

export default function InfoPage({ onClose }) {
  return (
    <div className="info-page-fullscreen">
      <div className="close-info-btn" onClick={onClose}>
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round">
          <line x1="21" y1="7" x2="7" y2="21" />
          <line x1="7" y1="7" x2="21" y2="21" />
        </svg>
      </div>
      <div className="info-content">
        <h1>Karel Berréhouc</h1>
        <div className="info-right-column">
          <h2>Compositeur, ingénieur son</h2>
          <div className="contact-info">
            <img src="/whatsapp.png" alt="WhatsApp" className="whatsapp-icon" />
            <span className="phone-number">07 83 71 35 66</span>
          </div>
        </div>
      </div>
    </div>
  );
}
